
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

interface ChartProps {
  type: "bar" | "pie";
  data: any[];
  index: string;
  categories: string[];
  colors: string[];
  valueFormatter?: (value: any) => string;
}

export const Chart = ({
  type,
  data,
  index,
  categories,
  colors,
  valueFormatter = (value) => `${value}`,
}: ChartProps) => {
  // If data is empty, show a placeholder
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-full w-full bg-muted/20 rounded-md border border-dashed">
        <p className="text-muted-foreground">No data to display</p>
      </div>
    );
  }

  if (type === "bar") {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={index} />
          <YAxis />
          <Tooltip formatter={(value) => valueFormatter(value)} />
          <Legend />
          {categories.map((category, i) => (
            <Bar
              key={category}
              dataKey={category}
              fill={colors[i % colors.length]}
              name={category}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    );
  }

  if (type === "pie") {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, value }) => `${name}: ${valueFormatter(value)}`}
            outerRadius={80}
            fill="#8884d8"
            dataKey={categories[0]}
            nameKey={index}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => valueFormatter(value)} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    );
  }

  return null;
};
